





import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class Pentagon extends Vue {
  @Prop()
  size?: string
  @Prop()
  borderColor?: string
  @Prop()
  backgroundColor?: string

  get baseStyles(): { [key: string]: string } {
    return {
      '--width': this.size ? this.size : '30px',
      '--background-color': this.backgroundColor ? this.backgroundColor : 'white',
      '--border-color': this.borderColor ? this.borderColor : 'black',
    }
  }
}
